<script setup lang="ts">
import { UserManagement } from '@/components/users';
import { useFormStore } from '@/stores/forms';
import { onMounted } from 'vue';

const formStore = useFormStore();

onMounted(async () => {
  await formStore.getStudyForms();
});
</script>

<template>
  <div class="activity-container">
    <UserManagement />
  </div>
</template>

<style scoped lang="scss">
.activity-container {
  height: 100%;
}
</style>
